export default __webpack_public_path__ + "static/media/logoHandNew.a15101d1.svg";